





























































import Vue from 'vue'
import KeySelector from '@/components/KeySelector.vue'
import TrainingPlayer from '@/components/TrainingPlayer.vue'
import TrainingMenu from '@/components/TrainingMenu.vue'
import { TRIAD, SEVENTH } from '../application/models/chords'
import { octaves as allowedOctaves } from '@/application/models/octaves'
import hasBreakpoints from '@/mixins/hasBreakpoints'

const allowedVariants = [TRIAD, SEVENTH].map(v => v.toString())

export default Vue.extend({
  mixins: [hasBreakpoints],
  components: {
    KeySelector,
    TrainingPlayer,
    TrainingMenu
  },
  data() {
    return {
      degrees: undefined as number[] | undefined,
      variants: undefined as string[] | undefined,
      inversions: undefined as boolean | undefined,
      octaves: undefined as number[] | undefined,
      custom: false,
      canShare: !!navigator.share
    }
  },
  watch: {
    '$route.query': {
      handler() {
        const { degrees, variants, inversions, octaves, custom } = this.$route.query
        const degreeArr: number[] | undefined = degrees ? (degrees as string).split(',').map(d => +d).filter(d => d >= 1 && d <= 7).slice(0, 4) : undefined
        const variantsArr: string[] | undefined = variants ? (variants as string).split(',').map(v => v.toLowerCase().trim()).filter(v => allowedVariants.includes(v)) : undefined
        const inversionsBool: boolean | undefined = inversions ? inversions === 'true' : undefined
        const octavesArr: number[] | undefined = octaves ? (octaves as string).split(',').map(o => +o).filter(o => allowedOctaves.includes(o)) : undefined
        this.degrees = degreeArr,
        this.variants = variantsArr,
        this.inversions = inversionsBool,
        this.octaves = octavesArr
        this.custom = custom === 'true'
      },
      immediate: true
    }
  }
})
